import { detectInstallPlatform, readPwaStandalone } from '../features/auth/utils/pwa-install';

/**
 * iOS 27 (release): PWA na Home Screen abre com um blur “preso” no topo
 * (inclusive sobre a safe area). Relatado em MacRumors — um scroll desfaz até
 * o próximo cold start. Meta status-bar é ignorada desde o beta.
 *
 * @see https://forums.macrumors.com/threads/ios-27-pwa-blurred-across-top-of-screen.2489325/
 */
export function shouldNudgeIosPwaTopChrome(
  standalone = typeof window !== 'undefined' && readPwaStandalone(),
  platform =
    typeof navigator !== 'undefined'
      ? detectInstallPlatform(navigator.userAgent, navigator.maxTouchPoints)
      : 'desktop',
): boolean {
  return standalone && platform === 'ios';
}

/** Empurra 1px no scroller e volta — força o WebKit a re-compor o chrome. */
export function nudgeIosPwaTopChrome(
  scrollEl: HTMLElement | null | undefined,
  enabled = shouldNudgeIosPwaTopChrome(),
): void {
  if (!enabled || !scrollEl) return;

  const top = scrollEl.scrollTop;
  // Telas sem overflow não aceitam scrollTop; spacer temporário libera 1px.
  let spacer: HTMLDivElement | null = null;
  const canMeasure =
    typeof scrollEl.scrollHeight === 'number' && typeof scrollEl.clientHeight === 'number';
  if (canMeasure && scrollEl.scrollHeight <= scrollEl.clientHeight + 1) {
    spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.height = '2px';
    spacer.style.flexShrink = '0';
    spacer.style.pointerEvents = 'none';
    scrollEl.appendChild(spacer);
  }

  scrollEl.scrollTop = top + 1;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollEl.scrollTop = top;
      spacer?.remove();
    });
  });
}
